import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Container from './Container';

const ClickOutside = ({ children, onClickOutside, ...props }) => {
  const node = useRef();

  useEffect(() => {
    const onDocumentClick = event => {
      if (!node.current.contains(event.target)) {
        onClickOutside(event);
      }
    };
    document.addEventListener('mousedown', onDocumentClick);
    document.addEventListener('touchstart', onDocumentClick);
    return () => {
      document.removeEventListener('mousedown', onDocumentClick);
      document.removeEventListener('touchstart', onDocumentClick);
    };
  }, [onClickOutside]);

  return (
    <Container position="relative" display="inline-block" ref={node} {...props}>
      {children}
    </Container>
  );
};

ClickOutside.propTypes = {
  children: PropTypes.node,
  onClickOutside: PropTypes.func,
};

ClickOutside.defaultProps = {
  children: null,
  onClickOutside: () => {},
};

export default ClickOutside;
